import React from 'react';
import { SyllabusNavigator } from '../components/SyllabusNavigator';
import { useNavigate } from 'react-router-dom';
import { Section, Card, CardBody } from '../components/BaseComponents';

/**
 * CategoryBrowser - Updated component for browsing the syllabus hierarchy
 *
 * This component uses the new SyllabusNavigator to provide hierarchical browsing
 * through the database-aligned syllabus structure and allows quiz generation
 * from any level of the hierarchy.
 */
export const CategoryBrowser: React.FC = () => {
  const navigate = useNavigate();

  const handleQuizGenerated = (attemptId: string) => {
    navigate(`/quiz/${attemptId}`);
  };

  return (
    <div className="min-h-screen">
      <div className="container mx-auto py-8 px-4">
        {/* Hero Section */}
        <Section
          title="Browse & Generate Quizzes"
          subtitle="Navigate through the curriculum hierarchy to find specific topics and generate customized quizzes"
          className="mb-8"
          titleClassName="text-2xl font-semibold text-neutral-900"
        >
          {/* Syllabus Navigation */}
          <Card className="border border-neutral-200" noHover={true}>
            <CardBody>
              <SyllabusNavigator
                showQuizGeneration={true}
                onQuizGenerated={handleQuizGenerated}
              />
            </CardBody>
          </Card>
        </Section>
      </div>
    </div>
  );
};
